import { motion } from "framer-motion";
// import Bgcolor from "./Bgcolor";
const Service = () => {
    const service = [
        {
            title:"Web Development",image:"./img/website.webp",delay: 0.1
        },
        {
            title:"Database Management",image:"./img/cloud-server.webp",delay: 0.1
        },
        {
            title:"Configuration Server",image:"./img/virtual-host.webp",delay: 0.1
        },
    ];
    return(
        // md:flex-row sm:flex-col
       <div className="">
            <div className="flex flex-col items-center justify-center md:w-full">
                <motion.div className=" w-full sm:w-full mb-8" 
                 initial={{ opacity: 0, y: 50 }}
                 whileInView={{ opacity: 1, y: 0 }} 
                 transition={{ duration: 1.2, ease: "easeOut" }}
                 viewport={{ once: false, amount: 0.2 }} // jalan berulang, trigger saat 20% terlihat
                 >
                    <div className="gap-4 sm:gap-4 md:gap-6">
                        <h3 className="text-5xl sm:text-5xl md:text-6xl font-extrabold bg-gradient-to-r from-blue-500 via-indigo-600 to-purple-700 text-center bg-clip-text text-transparent ">
                            Service
                        </h3>
                    </div>
                </motion.div>                
                <motion.div className=" mt-10 sm:mt-10 md:mt-10 md:mb-8" 
                        initial={{ opacity: 0, y: 50 }} 
                        whileInView={{ opacity: 1, y: 0 }} 
                        transition={{ duration: 1.2, ease: "easeOut" }}
                        viewport={{ once: false, amount: 0.2 }} // jalan berulang, trigger saat 20% terlihat
                        >
                    <div className="md:w-screen  items-center justify-center">
                       <div className="flex flex-col md:flex-row w-full sm:max-w-[600px] md:max-w-[900px] lg:max-w-[1200px] h-auto md:h-500 mx-auto gap-10 p-4 shadow-lg bg-[#fafafa] rounded-xl  ">
                        {/* <div><Bgcolor></Bgcolor></div> */}
                        {service.map((item,index) =>(
                            <div key={index} className="w-full sm:w-full md:w-1/2 md:p-8 sm:p-2 mx-auto ">
                                {/* Render konten skill di sini */}
                                <img src={item.image} alt={item.title} className="w-1/4 sm:w-1/4 sm:h-auto md:h-auto md:w-32 mx-auto" />
                                <p className="text-center text-balance text-xl sm:text-sm md:text-xl font-semibold tracking-tight text-gray-900">{item.title}</p>
                            </div> 
                        ))}
                       </div>
                    </div>
                </motion.div>
            </div>
        </div>
    );
}
export default Service;